import * as React from 'react';
import { StudyItemData } from '../study_items/types';
import { PracticePreviewData } from '../study_schedule/types';
import trackEvent from 'utilities/track_event';
import * as api from '../study_schedule/api';
import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';
import PopupBanner from '@magoosh/lib/popup_banner';

export interface StudyItemListProps {
  studyItems?: StudyItemData[];
  setItemCompleted: (number, boolean) => void;
}

export interface StudyItemListState {
  practicePreview?: PracticePreviewData;
  errorMessage?: string;
}

export default class StudyItemList<
  P extends StudyItemListProps,
  S extends StudyItemListState
> extends React.Component<P, S> {
  listType = 'StudyItemList';

  handleItemClick = (item: StudyItemData, completionCallback: () => void) => {
    trackEvent(`${this.listType} > Click Study Item`, {
      study_schedule_item_id: item.id,
      study_schedule_item_name: item.name
    });

    if (item.type === 'Misc') {
      if (item.url) {
        window.open(item.url, '_blank');
      }

      this.handleChangeItemState(item, true);
      completionCallback();
    } else if (['Review', 'Flashcards', 'Series', 'Lesson Quiz', 'Practice Test'].includes(item.type)) {
      this.handleChangeItemState(item, true).then(() => {
        window.location.assign(item.url);
      });
    } else if (item.type === 'Lesson' || item.type === 'Admissions') {
      window.location.assign(item.url);
    } else {
      if (item.url.indexOf('/practices/start') !== -1) {
        window.location.assign(item.url);
      } else {
        this.fetchPractice(item.id, completionCallback);
      }
    }
  };

  protected handleChangeItemState(item: StudyItemData, isCompleted: boolean) {
    // Track in Mixpanel
    if (isCompleted) {
      trackEvent('Study Schedule > Complete Study Item', {
        study_schedule_item_id: item.id,
        study_schedule_item_name: item.name
      });
    }

    // Update the UI quickly to give the user feedback. Very unlikely the request will fail
    this.props.setItemCompleted(item.id, isCompleted);
    return api.recordContentBlockProgress(item.id, isCompleted);
  }

  fetchPractice(blockId: number, clickCompletionCallback) {
    fetch(paths.api.studySchedulePractice(blockId), {
      method: 'POST'
    })
      .then((response) => {
        clickCompletionCallback();
        this.handleFetchPracticeResponse(response);
      })
      .catch((response) => {
        clickCompletionCallback();
        this.handleFetchPracticeError(response);
      });
  }

  handleFetchPracticeResponse(response) {
    if (response.preview) {
      this.setState({ practicePreview: response.preview });
    } else if (response.redirect) {
      window.location.assign(response.redirect);
    }
  }

  handleFetchPracticeError(response) {
    this.setState({ errorMessage: response.errors._error });
  }

  onClosePreviewModal() {
    this.setState({ practicePreview: null });
  }

  renderErrorMessage() {
    console.log(this.state.errorMessage);
    return (
      <PopupBanner bsStyle={'danger'} onSelfDestruct={() => this.setState({ errorMessage: null })}>
        {this.state.errorMessage}
      </PopupBanner>
    );
  }
}
